import * as bootstrap from 'bootstrap';
import Modal from 'bootstrap/js/dist/modal'


/*

// Add your custom JS here.
jQuery(function () {
  // Add event on the added_to_cart event, which is triggered by woocommerce 
  // when an item is added to the cart from the shop page
  // Adding of item from sinlge product page does not trigger this event and is handle in custom_actions.php
  jQuery('body').on('added_to_cart', function (event, fragments, cart_hash, button) {
    if (typeof maybeObject !== "undefined") {
      dataLayer.push({
        ecommerce: null
      }); // Clear the previous ecommerce object.
      dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: "USD",
          value: 100,
          items: [{
            item_id: button.data('product_id') + "",
          }]
        }
      });
    }
  });
});

jQuery('document').ready(function () {
  // report to analytics when a user views the cart page
  if (wc_add_to_cart_params && wc_add_to_cart_params.is_cart) {

    // this element is available after page load so we need to wait
    waitForEl('.wc-block-components-totals-footer-item-tax-value', function () {
      var totals = jQuery('.wc-block-components-totals-footer-item-tax-value');
      if (totals.length > 0) {
        var total = parseInt(totals[0].innerText.substring(4).replace('\'', ''));

        if (typeof maybeObject !== "undefined") {
          dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
          dataLayer.push({
            event: "view_cart",
            ecommerce: {
              currency: "USD",
              value: total,
            }
          });
        }
      }
    });
  }
});

// function updateCartState() {
//   jQuery('.widget_shopping_cart_content').find('.woocommerce-mini-cart-item').length
// }

// const myModalEl = document.getElementById('myModal')
// document.body.addEventListener('added_to_cart', function(event, fragments, cart_hash) {
//   console.log('Product added to cart!');

//   // Execute your custom logic here
//   alert('A product has been added to the cart!');
//   console.log(event, fragments, cart_hash);

//   // Example: Send data to analytics
//   // Example: ga('send', 'event', 'Cart', 'Add', 'Product Name');
// });



// document.addEventListener('DOMContentLoaded', function () {
//   const href = window.location.href;

//   if (href == "https://idzumi.ch/" || href == 'http://localhost:3000/') {
//     var myModal = new Modal(document.getElementById('myModal'));
//     myModal.show();
//   }
// });

var waitForEl = function (selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function () {
      waitForEl(selector, callback);
    }, 100);
  }
};

*/

jQuery(function ($) {
  handleBookingIframe($);
});


function handleBookingIframe($) {
  const modalElement = document.getElementById("sbModal");
  const iframe = document.getElementById("sbFrame");
  const modal = new bootstrap.Modal(modalElement);

  // TODO see if I can put event listener on .sb-open
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".sb-open");
    if (!btn) return;

    e.preventDefault();

    const url = btn.getAttribute("data-sb-url");
    if (!url) return;

    const serviceModalId = btn.getAttribute("data-sb-id");
  
    $(`#${serviceModalId}`).find('.btn-close').click();

    iframe.src = url;
    modal.show();
  });

  modalElement.addEventListener("hidden.bs.modal", function () {
    iframe.src = ""; // unload widget when closed
  });
}
